import './index.css'
export const CounterBox = ({ content }) => (
<div className="counter-box">
    <h6 className='count'>{content}/12</h6>
</div>
);
